import Confirm from 'carbon-react/lib/components/confirm';
import Typography from 'carbon-react/lib/components/typography';
import I18njs from 'i18n-js';
import styled from 'styled-components';
import Translate from '../../../../components/Translate/Translate';
import { TimesheetsStore } from '../../../../types/redux/stores/timesheets.types';
import { TimesheetsList } from './TimesheetsList';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space[2]};
`;

interface DeleteTimesheetsModalProps {
  ids: string[];
  timesheets: TimesheetsStore;
  onClose: () => void;
  onOk: () => void;
}

export const DeleteTimesheetsModal = ({ ids, onClose, onOk, timesheets }: DeleteTimesheetsModalProps) => {
  const data = timesheets.data.timesheets.filter((t) => ids.includes(t.id));

  return (
    <Confirm
      confirmButtonDestructive
      onCancel={() => onClose()}
      onConfirm={() => {
        onOk();
        onClose();
      }}
      cancelLabel={I18njs.t('timesheets.Cancel')}
      confirmLabel={I18njs.t('timesheets.Delete')}
      open={true}
      title={I18njs.t('timesheets.DeleteTimesheets', { count: ids.length })}
      size="medium"
    >
      <Content>
        <Typography variant="strong" display="block">
          <Translate
            scope="timesheets.AreYouSure"
            options={{
              count: ids.length,
            }}
          />
        </Typography>
        <TimesheetsList timesheets={data} />
      </Content>
    </Confirm>
  );
};
